import script from "./Events.vue?vue&type=script&lang=ts&setup=true"
export * from "./Events.vue?vue&type=script&lang=ts&setup=true"

import "./Events.vue?vue&type=style&index=0&id=5ef868cc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ef868cc"]])

export default __exports__